/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * - ACTIVE means that user can use the system in every way possbile - ARCHIVED means that user cannot login permanently and their email can be reused - INACTIVE means that user cannot login being in that status, cannot use the system, but can be later activated 
 */
export type UserStatus = 'ACTIVE' | 'ARCHIVED' | 'INACTIVE';

export const UserStatus = {
    Active: 'ACTIVE' as UserStatus,
    Archived: 'ARCHIVED' as UserStatus,
    Inactive: 'INACTIVE' as UserStatus
};

